import React, { Component } from 'react'
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'
import FlatButton from 'material-ui/FlatButton'
import CheckCircle from 'material-ui/svg-icons/action/check-circle'
import { FormattedMessage } from 'react-intl'
import ReactTooltip from 'react-tooltip'

import { checkJapanese, getTimezones, getToken } from '../../../lib'

const allTimezones = getTimezones()

const bitrate_const = [
  {bitrate: 0, label: 'Select Bitrate'},
  {bitrate: 2000000, label: '2Mbps'},
  {bitrate: 1500000, label: '1.5Mbps'},
  {bitrate: 1000000, label: '1Mbps'},
  {bitrate: 500000, label: '500Kbps'},
  {bitrate: 320000, label: '320Kbps'},
  {bitrate: 150000, label: '150Kbps'},
  {bitrate: 32000, label: '32Kbps'}]

const bitrate_const_map = {
  0: 'Select Bitrate',
  2000000: '2Mbps',
  1500000: '1.5Mbps',
  1000000: '1Mbps',
  500000: '500Kbps',
  320000: '320Kbps',
  150000: '150Kbps',
  32000: '32Kbps'
}

const codec_const = [
  {codec: 'h264', label: 'h264'},
  {codec: 'vp8', label: 'vp8'}

]

function swap (json) {
  var ret = {}
  for (var key in json) {
    ret[json[key]] = key
  }
  return ret
}

const bitrate_const_map_reverse = swap(bitrate_const_map)

class Settings extends Component {
  state = {
    timeValue: this.props.conferenceDetails.timezone
      ? this.props.conferenceDetails.timezone
      : allTimezones[318],
    languageValue: this.props.conferenceDetails.language
      ? this.props.conferenceDetails.language
      : 'jp',
    bitrateValue: bitrate_const_map[this.props.conferenceDetails.bit_rate],
    changedValues: 0,
    turnValue: this.props.conferenceDetails.turn ? 'ON' : 'OFF',
    codecValue: this.props.conferenceDetails.codec
  }

  handleTimeChange = (event, index, timeValue) => {
    let {changedValues} = this.state
    changedValues++
    this.setState({timeValue, changedValues})
  }
  handleLanguageChange = (event, index, languageValue) => {
    let {changedValues} = this.state
    changedValues++
    this.setState({languageValue, changedValues})
  }
  handleTurnChange = (event, index, turnValue) => {
    let {changedValues} = this.state
    changedValues++
    this.setState({turnValue, changedValues})
  }

  handleCodecChange = (event, index, codecValue) => {
    let {changedValues} = this.state
    changedValues++
    this.setState({codecValue, changedValues})
  }

  handleBitrateChange = (event, index, bitrateValue) => {
    let {changedValues} = this.state
    if (index == 0) {
      bitrateValue = '500Kbps'
    }
    changedValues++
    this.setState({bitrateValue, changedValues})
  }

  handleSubmit = e => {
    e.preventDefault()
    const {timeValue, languageValue, bitrateValue} = this.state
    const turn = (this.state.turnValue === 'ON') ? true : false
    const {selectConferenceId} = this.props
    const token = getToken()
    const codec = this.state.codecValue
    console.log(turn)
    this.props.updateConferenceSettings(
      token,
      selectConferenceId,
      languageValue,
      timeValue,
      bitrate_const_map_reverse[bitrateValue],
      turn,
      codec
    )
  }

  render () {
    return (
      <form style={{width: '448px'}} onSubmit={this.handleSubmit}>
        <ReactTooltip place="left" multiline effect="solid" html/>
        <div style={{fontSize: 16, color: '#6B7C93'}}>
          <FormattedMessage id="inviteModal.settings.global"/>
          {this.props.conferenceDetails.name}
        </div>

        {false && <div>{!this.props.guest ? (
          <SelectField
            data-tip={`
              <div
                class='pb2 custom-tooltip'>
                ${checkJapanese(this.props.pathname)
              ? 'セミナー開催時刻のタイムゾーンを設定してください。'
              : 'Change this if you need to create the seminar globally.'}
              </div>`}
            selectedMenuItemStyle={{
              backgroundColor: 'rgba(136, 224, 168, 0.18)',
              color: '#29B87A'
            }}
            floatingLabelText={
              <FormattedMessage id="inviteModal.settings.timezone"/>
            }
            value={this.state.timeValue}
            onChange={this.handleTimeChange}
            menuItemStyle={{height: 48, paddingTop: 8}}
            style={{width: '100%'}}>
            {allTimezones.map((val, index) => (
              <MenuItem
                key={index}
                value={val}
                primaryText={val}
                rightIcon={
                  this.state.timeValue === {val} ? (
                    <CheckCircle style={{fill: '#29B87A'}}/>
                  ) : (
                    <div/>
                  )
                }
              />
            ))}
          </SelectField>
        ) : (
          <div className="mt3">
            <div
              data-tip={`
              <div
                class='pb2 custom-tooltip'>
                ${checkJapanese(this.props.pathname)
                ? 'セミナーの開催のタイムゾーンです。'
                : 'Time zone used in this seminar'}
              </div>`}
              className="mb2"
              style={{fontSize: 12, color: 'rgba(107, 124, 147, 0.5)'}}>
              <FormattedMessage id="inviteModal.settings.timezone"/>
            </div>
            <div>
              {this.props.conferenceDetails.timezone ? (
                this.props.conferenceDetails.timezone
              ) : (
                'GMT+9:00 Japan Standard Time'
              )}
            </div>
          </div>
        )}</div>}

        {false && <div>{!this.props.guest ? (
          <SelectField
            selectedMenuItemStyle={{
              backgroundColor: 'rgba(136, 224, 168, 0.18)',
              color: '#29B87A'
            }}
            data-tip={`
              <div
                class='pb2 custom-tooltip'>
                ${checkJapanese(this.props.pathname)
              ? 'セミナーで使用される言語を\n選択してください。'
              : 'Set the language used in the seminar'}
              </div>`}
            floatingLabelText={
              <FormattedMessage id="inviteModal.settings.language"/>
            }
            value={this.state.languageValue}
            onChange={this.handleLanguageChange}
            menuItemStyle={{height: 48, paddingTop: 8}}
            autoWidth
            dropDownMenuProps={{
              anchorOrigin: {vertical: 'top', horizontal: 'right'},
              targetOrigin: {vertical: 'top', horizontal: 'right'}
            }}
            fullWidth>
            <MenuItem
              value="en"
              primaryText="English"
              rightIcon={
                this.state.languageValue === 'English' ? (
                  <CheckCircle style={{fill: '#29B87A'}}/>
                ) : (
                  <div/>
                )
              }
            />
            <MenuItem
              value="jp"
              primaryText="日本語"
              rightIcon={
                this.state.languageValue === '日本語' ? (
                  <CheckCircle style={{fill: '#29B87A'}}/>
                ) : (
                  <div/>
                )
              }
            />
          </SelectField>
        ) : (
          <div className="mt3">
            <div
              data-tip={`
              <div
                class='pb2 custom-tooltip'>
                ${checkJapanese(this.props.pathname)
                ? 'セミナーで使用される言語です。'
                : 'The language used in the seminar'}
              </div>`}
              className="mb2"
              style={{fontSize: 12, color: 'rgba(107, 124, 147, 0.5)'}}>
              <FormattedMessage id="inviteModal.settings.language"/>
            </div>
            <div>
              {this.props.conferenceDetails.language ? (
                this.props.conferenceDetails.language
              ) : (
                'English'
              )}
            </div>
          </div>
        )}</div>}


        {!this.props.guest ? (
          <SelectField
            selectedMenuItemStyle={{
              backgroundColor: 'rgba(136, 224, 168, 0.18)',
              color: '#29B87A'
            }}
            data-tip={`
              <div
                class='pb2 custom-tooltip'>
                ${checkJapanese(this.props.pathname)
              ? 'ビットレートを選択してください。'
              : 'Set the language used in the seminar'}
              </div>`}
            floatingLabelText={
              <FormattedMessage id="inviteModal.settings.bitrate"/>
            }
            value={this.state.bitrateValue}
            onChange={this.handleBitrateChange}
            menuItemStyle={{height: 48, paddingTop: 8}}
            autoWidth
            dropDownMenuProps={{
              anchorOrigin: {vertical: 'top', horizontal: 'right'},
              targetOrigin: {vertical: 'top', horizontal: 'right'}
            }}
            fullWidth>
            {bitrate_const.map((value, index) => {
              return (
                <MenuItem
                  key={index}
                  value={value.label}
                  primaryText={value.label}
                  rightIcon={(this.state.bitrateValue === value.bitrate)
                    ? (<CheckCircle style={{fill: '#29B87A'}}/>) : (<div/>)}/>
              )
            })}
          </SelectField>
        ) : (
          <div className="mt3">
            <div
              data-tip={`
              <div
                class='pb2 custom-tooltip'>
                ${checkJapanese(this.props.pathname)
                ? 'セミナーで使用される送信ビットレートです。'
                : 'Birate for sending video and audio '}
              </div>`}
              className="mb2"
              style={{fontSize: 12, color: 'rgba(107, 124, 147, 0.5)'}}>
              <FormattedMessage id="inviteModal.settings.bitrate"/>
            </div>
            <div>
              {bitrate_const_map[this.props.conferenceDetails.bit_rate]}
            </div>
          </div>
        )}

        {!this.props.guest ? (
          <SelectField
            selectedMenuItemStyle={{
              backgroundColor: 'rgba(136, 224, 168, 0.18)',
              color: '#29B87A'
            }}
            data-tip={`
              <div
                class='pb2 custom-tooltip'>
                ${checkJapanese(this.props.pathname)
              ? 'h264非対応Android端末をサポートする場合はvp8を選択'
              : 'use vp8 for the Android cannot use h264'}
              </div>`}
            floatingLabelText={
              <FormattedMessage id="inviteModal.settings.videoCodec"/>
            }
            value={this.state.codecValue}
            onChange={this.handleCodecChange}
            menuItemStyle={{height: 48, paddingTop: 8}}
            autoWidth
            dropDownMenuProps={{
              anchorOrigin: {vertical: 'top', horizontal: 'right'},
              targetOrigin: {vertical: 'top', horizontal: 'right'}
            }}
            fullWidth>
            {codec_const.map((value, index) => {
              return (
                <MenuItem
                  key={index}
                  value={value.label}
                  primaryText={value.label}
                  rightIcon={(this.state.codecValue === value.codec)
                    ? (<CheckCircle style={{fill: '#29B87A'}}/>) : (<div/>)}/>
              )
            })}
          </SelectField>
        ) : (
          <div className="mt3">
            <div
              data-tip={`
              <div
                class='pb2 custom-tooltip'>
                ${checkJapanese(this.props.pathname)
                ? 'h264非対応Android端末をサポートする場合はvp8を選択'
                : 'use vp8 for the Android cannot use h264'}
              </div>`}
              className="mb2"
              style={{fontSize: 12, color: 'rgba(107, 124, 147, 0.5)'}}>
              {<FormattedMessage id="inviteModal.settings.videoCodec"/>}
            </div>
            <div>
              {this.props.conferenceDetails.codec}
            </div>
          </div>
        )}

        {this.state.changedValues >= 1 ? (
          <div>
            <div className="flex justify-center">
              <div>
                <FlatButton
                  label={<FormattedMessage id="loggedInNavigation.cancel"/>}
                  fullWidth
                />
              </div>
              <div className="ml2">
                <FlatButton
                  type="submit"
                  label={<FormattedMessage id="seminar.save"/>}
                  fullWidth
                  backgroundColor="#45CE90"
                  labelStyle={{color: '#FFFFFF'}}
                />
              </div>
            </div>
          </div>
        ) : (
          ''
        )}
      </form>
    )
  }
}

export default Settings



// WEBPACK FOOTER //
// ./src/components/Seminars/SeminarActions/Settings.js